import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PortsideStripe } from "@/components/Brand";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#f8fafc]">
        <PortsideStripe />
        <div className="grid place-items-center h-[60vh]">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 rounded-full border-4 border-slate-200 border-t-[#ff5b2c] animate-spin" />
            <div className="overline">Authenticating</div>
          </div>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.status !== "approved") return <Navigate to="/pending" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/inspection/entry" replace />;
  return children;
}
